import { Box, Typography } from '@mui/material';
import { formatCurrency } from '../../utils';

interface PayoutOverviewProps {
  referrer: string;
  payoutMonth: string;
  commission: number;
}

const labelStyle = {
  fontFamily: 'Manrope, sans-serif',
  fontWeight: 700,
  fontSize: '0.75rem',
  marginBottom: '0.25rem',
  color: '#6C6C6C',
};

const textStyle = {
  fontFamily: 'Manrope, sans-serif',
  fontWeight: 700,
  fontSize: '1rem',
  color: '#162936',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const PayoutOverview: React.FC<PayoutOverviewProps> = ({ referrer, payoutMonth, commission }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '1rem',
        padding: '1rem',
        backgroundColor: '#fff',
        borderRadius: '12px',
      }}
    >
      <Box>
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography sx={labelStyle}>Referrer</Typography>
          <Typography sx={textStyle}>{referrer}</Typography>
        </Box>
      </Box>

      <Box>
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography sx={labelStyle}>Payout Month</Typography>
          <Typography sx={textStyle}>{payoutMonth}</Typography>
        </Box>
      </Box>

      <Box>
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography sx={labelStyle}>Commission</Typography>
          <Typography sx={textStyle}>{formatCurrency(commission)}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PayoutOverview;
